import { render, staticRenderFns } from "./DialogIdeaSettings.vue?vue&type=template&id=01e2b0f8&scoped=true"
import script from "./DialogIdeaSettings.vue?vue&type=script&lang=js"
export * from "./DialogIdeaSettings.vue?vue&type=script&lang=js"
import style0 from "./DialogIdeaSettings.vue?vue&type=style&index=0&id=01e2b0f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e2b0f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e2b0f8')) {
      api.createRecord('01e2b0f8', component.options)
    } else {
      api.reload('01e2b0f8', component.options)
    }
    module.hot.accept("./DialogIdeaSettings.vue?vue&type=template&id=01e2b0f8&scoped=true", function () {
      api.rerender('01e2b0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SelectIdea/Dialogs/DialogIdeaSettings.vue"
export default component.exports